import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/icons/Menu';
import React from 'react';
import { connect } from 'react-redux';
import ThemeLogo from 'src/common/components/theme-logo/theme-logo';
import { AppState } from 'src/common/redux/configure-store';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import MenuPanelWrapper from '../../menu-panel/components/menu-panel-wrapper';
import { ReactComponent as Alert } from 'src/common/media/pay-attention.svg';
import { newStyles } from './login-emerald-styles';
import NTEPCertification from 'src/home-page/components/home-page-layout/ntep-certification';

interface IEmeraldSignageProps {
  welcomeClick: () => void;
  trainingMode?: boolean;
  hasUnhealthyDevices?: boolean;
}

const EmeraldSignage: React.FC<IEmeraldSignageProps> = ({
  welcomeClick,
  trainingMode,
  hasUnhealthyDevices,
}): JSX.Element => {
  const configuration = getCurrentXLRConfig();
  const classes = newStyles();

  return (
    <>
      <MenuPanelWrapper menuMode='login' />
      <Grid item sm={5} className={classes.signagebackground}>
        <Grid container spacing={1}>
          <Grid container spacing={3}>
            <Grid item sm={6} className={classes.menucontainer}>
              <Menu
                className={`${classes.menuicon} pointer`}
                data-testid='menu-btn'
                tabIndex={-1}
                onClick={() => {
                  welcomeClick();
                }}
              />
              {hasUnhealthyDevices && <Alert className={classes.loginDeviceIcon} />}
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.margintopsignagediv}>
          <Grid container item className={classes.normalProductLogoContainer}>
            <Grid
              container
              item
              className={`${classes.productcontainerbase} ${
                trainingMode ? classes.trainingproductcontainer : classes.normalproductcontainer
              }`}
            >
              <Grid container>
                <Typography variant='h5' className={classes.productnametypography}>
                  {configuration.productName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Grid
          container
          item
          justifyContent='center'
          alignItems='center'
          className={classes.signagebottomcontainer}
          sm={5}
        >
          <Grid container justifyContent='center' alignItems='center' wrap='nowrap'>
            <NTEPCertification className={classes.versiontypography} />
            <ThemeLogo styles={classes.brandlogostyle} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = (state: AppState): ReturnType<typeof mapStateToProps> => ({
  hasUnhealthyDevices: state.deviceStatus.devices.find(({ warning }) => warning),
});

export default connect(mapStateToProps)(EmeraldSignage);
